module.exports = __webpack_public_path__ + "static/media/signRequestSuccess.cee642ba.svg";